"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _querystring = _interopRequireDefault(require("querystring"));

var _commonReact = require("@devsta/common-react");

var _api = require("../../../common/api");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _Home = _interopRequireDefault(require("../components/Home"));

var _InspirationWrapper = require("../../../common/components/InspirationWrapper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Home(_ref) {
  var history = _ref.history,
      location = _ref.location;

  var queryParams = _querystring.default.parse(history.location.search.substr(1));

  return _react.default.createElement(_InspirationWrapper.InspirationOrgConsumer, null, function (_ref2) {
    var setSelectedOrgId = _ref2.setSelectedOrgId,
        selectedInspirationOrgId = _ref2.selectedInspirationOrgId,
        organisationMemberships = _ref2.organisationMemberships;
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        getOrganisation: (0, _api.getOrganisationApi)(selectedInspirationOrgId),
        getInspirationsHeader: (0, _api.getInspirationsHeaderApi)(selectedInspirationOrgId)
      }
    }, function (_ref3) {
      var getOrganisation = _ref3.getOrganisation,
          getInspirationsHeader = _ref3.getInspirationsHeader;
      return _react.default.createElement(_Home.default, {
        history: history,
        location: location,
        queryParams: queryParams,
        getOrganisation: getOrganisation,
        getInspirationsHeader: getInspirationsHeader,
        selectedInspirationOrgId: selectedInspirationOrgId,
        setSelectedOrgId: setSelectedOrgId,
        organisationMemberships: organisationMemberships
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, Home);

exports.default = _default;